import {HttpServices} from "../Helpers";
import {PHP_V13_URL} from "../api/urls";

export const GetAllPortalData = async ({language_uuid}) =>
  await HttpServices.get(
    `${PHP_V13_URL}/api/recruiter/career/portal/${process.env.REACT_APP_VERSION_API_V2}/get-internal-portal`,
    {
      params: {language_uuid},
    }
  )
    .then((data) => data)
    .catch((error) => error.response);
